import React from 'react'

function Reset() {
    return (
    <>
            <div class="container-fluid custom-page">
                <div class="row bg-white">
                    {/* <!-- The image half --> */}
                    <div class="col-md-6 col-lg-6 col-xl-7 d-none d-md-flex bg-primary-transparent-3">
                        <div class="row w-100 mx-auto text-center">
                            <div class="col-md-12 col-lg-12 col-xl-12 my-auto mx-auto w-100">
                                <img src="assets/images/media/pngs/6.png"
                                    class="my-auto ht-xl-80p wd-md-100p wd-xl-50p mx-auto" alt="logo"/>
                            </div>
                        </div>
                    </div>
                    {/* <!-- The content half --> */}
                    <div class="col-md-6 col-lg-6 col-xl-5 bg-white py-4">
                        <div class="login d-flex align-items-center py-2">
                            {/* <!-- Demo content--> */}
                            <div class="container p-0">
                                <div class="row">
                                    <div class="col-md-10 col-lg-10 col-xl-9 mx-auto">
                                        <div class="card-sigin">
                                            <div class="mb-5 d-flex">
                                                <a href="/" class="header-logo"><img src="assets/images/brand-logos/desktop-logo.png"
                                                    class="desktop-logo ht-40" alt="logo"/>
                                                    <img src="assets/images/brand-logos/desktop-white.png"
                                                        class="desktop-white ht-40" alt="logo"/>
                                                    </a>
                                                </div>
                                                    <div class="card-sigin">
                                                        <div class="main-signup-header">
                                                            <h3>Welcome back!</h3>
                                                            <h6 class="fw-medium mb-4 fs-17">Reset Your Password</h6>
                                                            <form>
                                                                <div class="form-group mb-3">
                                                                    <label class="form-label">Email</label> <input class="form-control"
                                                                        placeholder="Enter your email" type="text"/>
                                                                </div>
                                                                <div class="form-group mb-3">
                                                                    <label class="form-label">New Password</label> <input class="form-control"
                                                                        placeholder="Enter your New Password" type="text"/>
                                                                </div>
                                                                <div class="form-group mb-3">
                                                                    <label class="form-label">Confirm Password</label> <input class="form-control"
                                                                        placeholder="Enter your Confirm Password" type="password"/>
                                                                </div>
                                                                <a href="/" class="btn btn-primary btn-block w-100">Reset Password</a>
                                                            </form>
                                                            <div class="main-signin-footer mt-3">
                                                                <p>Already have an account? <a href="/Signin">Sign In</a></p>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* <!-- End --> */}
                            </div>
                        </div>
                        {/* <!-- End --> */}
                    </div>
                </div>

            </>
            )
}

            export default Reset